export default __webpack_public_path__ + "static/media/generalFilled.bd8f690e.svg";